export default "__VITE_ASSET__D4$dExaV__"